import { cliente } from '@/lib/cliente';
import type { PeriodoMaqSel } from '@/lib/cliente';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

/** Ingreso vs. gasto por máquina. Sin filtros globales; período propio de Maquinaria opcional. */
export function useMaquinariaAnalisisGeneral(periodoMaq?: PeriodoMaqSel) {
  return useQuery({
    queryKey: ['maquinaria-analisis-general', periodoMaq],
    queryFn: () => cliente.maquinaria.analisisGeneral(periodoMaq),
    placeholderData: keepPreviousData,
  });
}
